export const getUserName = () => {
  const profileDetailsString = sessionStorage.getItem("profile");
  if (profileDetailsString) {
    const user = JSON.parse(profileDetailsString);
    if (user.profile) {
      return `${user.profile?.given_name} ${user.profile?.family_name}`;
    }
    return `${user?.given_name} ${user?.family_name}`;
  }
  return null;
};

export const getUserEmail = () => {
  const profileDetailsString = sessionStorage.getItem("profile");
  if (profileDetailsString) {
    const user = JSON.parse(profileDetailsString);
    if (user.profile) {
      return `${user.profile.email}`;
    }
    return `${user.email}`;
  }
  return null;
};
